module.exports = __webpack_public_path__ + "assets/images/vcr_park-03.99c40235ae2103aaac110e333b145cc2.svg";